<template>
    <div class="header">
      <div class="text-center">
        <div class="login-logo">
          <h4 class="login-title">{{ $t('Login') }}</h4>
        </div>
        <div class="login-form">
          <form @submit.prevent="login">
            <div class="form-group">
              <input data-vv-validate-on="blur" v-validate="'required|email'"
                     v-model="auth.username" name="loginUsername" data-vv-as="Email" type="text"
                     :placeholder="$t('Email')" class="form-control">
              <span v-show="errors.has('loginUsername')"
                    class="text-danger">{{ errors.first('loginUsername') }}</span>
            </div>
            <div class="form-group">
              <input data-vv-validate-on="blur" v-validate="'required|min:6'"
                     v-model="auth.password" name="loginPassword" data-vv-as="Password"
                     type="password" :placeholder="$t('Password')" class="form-control">
              <span v-show="errors.has('loginPassword')"
                    class="text-danger">{{ errors.first('loginPassword') }}</span>
            </div>
            <div class="form-group">
              <div class="row login-buttons">
                <div class="col-12">
                  <button type="submit" class="btn btn-block login-btn btn-primary">
                    <span v-if="loginSpinner" class="fa fa-spinner fa-spin"></span>
                    <span v-else>{{ $t('Login') }}</span>
                  </button>
                </div>
              </div>
            </div>
            <div v-if="auth.logError" class="form-group text-danger">
              <span>{{ $t('Wrong email or password') }}</span>
              <br>
              <span>{{ $t('Please try again') }}</span>
            </div>
          </form>
        </div>
      </div>
    </div>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
import URL from "../../assets/js/URL-Parser/js/URLParser";
import register from './Register.vue'
import AutoComplete from '../../helpers/maps/AutoComplete'
import Geocode from '../../helpers/maps/Geocode'
import debounce from 'debounce'

export default {
    name: "login",
    data() {
        return {
            e: {
                error: false,
                errors: {
                    unvalidEmail: this.$t('The provided Email does not exists')
                }
            },
            recoverySpinner: false,
            loginSpinner: false,
            showLogin: true,
            recoveryEmail: null,
            trainerSearch: {
                city: "",
                buttonSpin: false
            },
            auth: {
                username: null,
                password: null,
                data: null,
                firstname: null,
                lastname: null,
                defaultAvatar: "profile_pictures/fmjIdqHgFPFeXTCwemoPrje73fHhBv2Twyx5XVD9.png",
                regError: false,
                logError: false,
                reg: {
                    username: null,
                    password: null
                }
            },
            optional: {
                org: false,
            },
            locationsList: null,
            locationSpinner: false,
        };
    },
    computed: {
        ...mapState({
            trainerId: state => state.trainerVisit,
            trainerList: state => state.frontPage.trainerSearch.trainerList
        })
    },
    mounted() {
        if (URL.get("affiliateLink")) {
            let exp = new Date();
            exp.setDate(exp.getDate() + 2);
            let affiliate = {
                link: URL.get("affiliateLink"),
                expiration: exp
            };
            localStorage.setItem("affiliate", JSON.stringify(affiliate));
        }
        if (URL.get('passwordToken')) {
            $('#resetPassModal').modal('show');
        }
    },
    methods: {
        toggleLogin() {
            this.showLogin = !this.showLogin;
        },
        login() {
            let vm = this;
            this.$validator.validateAll().then(result => {
                if (result) {
                    this.loginSpinner = true;
                    const apiData = {
                        ...process.env.api_data,
                        username: vm.auth.username,
                        password: vm.auth.password
                    }
                    axios
                        .post(process.env.hostname + "/oauth/token", apiData)
                        .then(response => {
                            $("#loginModal").modal("hide");
                            $("#registerModal").modal("hide");
                            vm.data = response;
                            this.$auth.setToken(
                                response.data.token_type + " " + response.data.access_token,
                                response.data.expires_in + Date.now()
                            );
                            if (vm.optional.org) {
                                localStorage.setItem('redirBcTrainer', true);
                            }
                            this.$router.push("/dashboard");
                        })
                        .catch(error => {
                            vm.auth.logError = true;
                            vm.loginSpinner = false;
                        });
                }
            });
            this.loginSpinner = false;
            setTimeout(function () {
                $('#registerModal').find('.text-danger');
            }, 1000);
        }
    }
};
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// src/components/frontpage/Login.vue